module.exports = __webpack_public_path__ + "static/media/icon_status_out.4ce567a0.svg";